import { RichTextNodeType } from "@prismicio/types";
const RichTextReversedNodeType = {
  [RichTextNodeType.listItem]: "listItem",
  [RichTextNodeType.oListItem]: "oListItem",
  [RichTextNodeType.list]: "list",
  [RichTextNodeType.oList]: "oList"
};
export {
  RichTextReversedNodeType
};
//# sourceMappingURL=types.js.map
